import React, { useEffect, useState, useRef } from 'react';
import { Card, Modal } from '@sede-enterprise/shell-ds-react-framework';
import { Row, Col } from '../../components/flexbox/Flex';
import { AnchorSpan, ContainerDiv } from '../../components/styledComponent/StyledComponent';
import { Link, Params, useNavigate, useParams } from 'react-router-dom';
import './styles.css';
import ErrorAlert from '../../components/errorAlert/ErrorAlert';

import { getData, postData, postDataFile } from '../../services/ApiService';
import { ApiUrls } from '../../helpers/ApiUrls';
import ResponseErrorModal from '../../components/responseErrorModal/ResponseErrorModal';
import BackButton from '../../components/backButton/BackButton';
import TicketForm from '../../components/ticketForm/TicketForm';
import { usePageTitle } from '../../services/UtilService';
import { useToast } from 'rc-toastr';
import Loader from '../../components/loader/Loader';
import { Constants } from '../../helpers/Constants';

import {APIErrorResponseInterface} from '../../helpers/InterfacesConstants'
import { useTranslation } from 'react-i18next';

interface formData{

    suppliedCustomerName?: string,
    suppliedCustomerCode?: string,
    suppliedAircraftRegistration?: string,
    suppliedCardNumber?: string,
    suppliedConco?: string,
    suppliedCreditType?: string,
    suppliedCustomerAccountNumber?: string,
    suppliedDelco?: string,
    suppliedDutyInd?: string,
    suppliedExternalInd?: string,
    suppliedFinalDestination?: string,
    suppliedFlightId?: string,
    suppliedNextDestination?: string,
    suppliedPackType?: string,
    suppliedVATInd?: string,

    nextDestinationResults?: {confirmedNextDestination: string, suppliedNextDestination: string}[],

    confirmedCustomerName? : string ,
    confirmedCustomerCode? : string,
    confirmedCreditType? : string,
    confirmedConco? : string,
    confirmedDelco? : string,
    confirmedCustomerAccountNumber?: string,
    confirmedCardNumber? : string,
    confirmedVATInd? : string,
    confirmedDutyInd? : string,
    confirmedExternalInd? : string,
    confirmedPackType? : string,
    confirmedAircraftRegistration? : string,
    confirmedFlightId? : string,
    confirmedFinalDestination? : string,
    comments? : string,
    filename?:File | null,
    editedBy?: string | null,
    modifiedDate? : string | null,
    version?: string,
    ticketNumber? : string,
    isLocalTicket? : boolean
};

const UpdateTicket = () => {
    const navigate = useNavigate();
    const transaction = useParams();
    const [ transactionData, setTransactionData] = useState<formData>({});

    const [open, setOpen] = useState(false);

    const hiddenFileInput = useRef<HTMLInputElement>(null);

    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

    const dataFetchedRef = useRef(false);


    const [errors , setErrors] = useState(null);

    const [cardNumbers, setCardNumbers] = useState<string[]>([]);

    const [creditTypes, setCreditTypes] = useState<{code:string, desc:string}[]>([]);

    const [customerAccountNumbers, setCustomerAccountNumbers] = useState<string[]>([]);

    const [ customers, setCustomers ] = useState<{customerId: string, CustomerCode: string, customerName: string}[]>([]);

    const [apiErrorResponse, setApiErrorResponse] = useState<APIErrorResponseInterface | null>();
    const [isLoading, setIsLoading] = useState(true);

    const { toast } = useToast();
    const { t } = useTranslation();
    usePageTitle(t('shellAviationAIMS')+" | Edit");

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
		getDetails(transaction);
	},[]);
    

    const getDetails = (transaction: Readonly<Params<string>>) =>{
        const url = ApiUrls.editDetails + transaction.headerId
        setIsLoading(true);
        getData(url).then((response) => {
            setTransactionData(response.data.ticketEditFieldResult);
            setErrors(response.data.transactionErrorDetail);
            setCardNumbers(response.data.customerCardDetail);
            setCustomerAccountNumbers(response.data.customerAccountNumber);
            setCreditTypes(response.data.creditTypes);
            setCustomers(response.data.editCustomerResults);
            setIsLoading(false);
        }).catch((error) => {
            setApiErrorResponse({
                message:error.response.data.message,
                traceId: error.response.data.traceId
            });
        });
    }


    const getRequestObject = (isSubmit:boolean) =>{
        const tempNextDestinations: {type: string, value: string}[] = [];

        transactionData.nextDestinationResults && transactionData.nextDestinationResults.map((nextDestination:{confirmedNextDestination: string, suppliedNextDestination: string}, index:number) => (
            tempNextDestinations.push({type: 'NDT'+(index+1) , value: nextDestination.confirmedNextDestination})
        ));
        
        return {
            "isSubmit": isSubmit,
            "isCorrection": false,
            "customerName": transactionData && transactionData.confirmedCustomerName,
            "customerCode": transactionData && transactionData.confirmedCustomerCode,
            "creditType": transactionData && transactionData.confirmedCreditType,
            "conco": transactionData && transactionData.confirmedConco,
            "delco": transactionData && transactionData.confirmedDelco,
            "customerAccountNumber": transactionData && transactionData.confirmedCustomerAccountNumber,
            "customerCardNumber": transactionData && transactionData.confirmedCardNumber,
            "vatInd": transactionData && transactionData.confirmedVATInd,
            "dutyInd": transactionData && transactionData.confirmedDutyInd,
            "externalInd": transactionData && transactionData.confirmedExternalInd,
            "aircraftRegistration": transactionData && transactionData.confirmedAircraftRegistration,
            "flightId": transactionData && transactionData.confirmedFlightId,
            "nextDestinations": tempNextDestinations,
            "nextDestination": null,
            "finalDestination": transactionData && transactionData.confirmedFinalDestination,
            "modifiedBy": '',
            "modifiedDate":'',
            "version":transactionData.version,

        };
    } 

    const getFileObject = () => {
        return {
            "reason" : transactionData && transactionData.comments,
            "file": transactionData && transactionData.filename
        };
    }
    
    const submitSuccessCallback = () => {
        toast.success('Submitted Successfully!');
        setOpen(false);
        navigate("/transactions/");
    }

    const submit = () =>{
        setOpen(true);
        const requestObj = getRequestObject(true);
        const url = ApiUrls.updateTransaction +  transaction.headerId;
        
        postData(url, requestObj).then((response)=>{
            const requestFileObject = getFileObject();
            if(requestFileObject.file || requestFileObject.reason){
                const uploadURL = ApiUrls.updateTransFileUpload +  transaction.headerId;
                postDataFile(uploadURL, requestFileObject).then((response)=>{
                    submitSuccessCallback();
                }).catch((error)=>{
                    setOpen(false);
                    setApiErrorResponse({
                        message:error.response.data.message,
                        traceId: error.response.data.traceId
                    });
                });
            }else{
                submitSuccessCallback();
            }
        }).catch((error)=>{
            setOpen(false);
            setApiErrorResponse({
                message:error.response.data.message,
                traceId: error.response.data.traceId
            });
        });
    }

    const cancel = () =>{
        navigate("/transactions/");
    }

    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(e.target.files){
            const fileList : FileList = e.target.files;
            const filesArray = Array.from(fileList) as File[];
            
            // Validate file types
            const invalidFiles = filesArray.filter(
                (file) =>
                !['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
                'application/vnd.ms-outlook', 
                'application/vnd.ms-excel',
                'application/pdf',
                'image/jpeg'].includes(
                    file.type
                )
            );
        
            if (invalidFiles.length > 0) {
                alert('Invalid file type. Please select valid files.');
                return;
            }

            const oversizedFiles = filesArray.filter(file => file.size > Constants.maxFileSizeInBytes);

            if (oversizedFiles.length > 0) {
                alert(`File size should be less than 1 MB. Please select valid files.`);
                return;
            }
            setSelectedFiles(filesArray);
            setTransactionData({...transactionData, "filename": fileList[0]});
        }
    };

    const attachmentClick = () =>{
        hiddenFileInput.current && hiddenFileInput.current.click();
    }
    
    const handleCancel = () => {
        // Clear selected files
        setSelectedFiles([]);
        setTransactionData({...transactionData, "filename": null});
    };

    const updateState = (obj: any) => {
        setTransactionData(obj);
    }
      
    return (
        <>
            <ContainerDiv>
                <Row>
                    <Col> 
                        <BackButton/>
                    </Col>
                </Row>

                <Row>
                    <Col size="30"> 
                        <h2 style={{margin:'0px'}}>Ticket# {transactionData.ticketNumber}</h2>
                    </Col>
                    <Col size="70"><AnchorSpan><Link to={"/transactions/"+transaction.headerId}>View Details</Link></AnchorSpan></Col>
                </Row>
            </ContainerDiv>

            <ContainerDiv>
                <Row>
                    { errors && 
                        <ErrorAlert errorDetails={errors}/>
                    }
                </Row>
            </ContainerDiv>

            <ContainerDiv>
                
                <Card>
                    {isLoading && <Loader />}
                    {!isLoading && (
                        <TicketForm transactionData={transactionData} onCancel={cancel} onSubmit={submit} onChange={updateState} creditTypes={creditTypes} cardNumbers={cardNumbers} customerAccountNumbers={customerAccountNumbers} customers={customers} handleFileUpload={handleFileUpload} selectedFiles={selectedFiles} onFileCancel={handleCancel}/>
                    )}
                </Card>
                
            </ContainerDiv>

            <Modal loading={true} loadingBody="Submitting your ticket... please wait." closable={false} open={open} onClose={() => {setOpen(false);}} />
            <ResponseErrorModal errorDetails={apiErrorResponse} isOpen={apiErrorResponse? true : false} onModalClose={()=>{setApiErrorResponse(null)}}/>
        </>
    )
}

export default UpdateTicket;